var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"content-header"},[_c('div',{staticClass:"content-header__container container-fluid"},[(_vm.type === 'h1')?_c('h1',{staticClass:"content-header__title"},[_vm._t("default")],2):_c('h2',{staticClass:"content-header__title"},[_vm._t("default")],2),_vm._t("numbers"),_vm._t("buttons")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }